import { all, call, put } from 'redux-saga/effects';

import {
  loadEveryoneLeaderboardWaiting,
  loadFriendLeaderboardWaiting,
  loadPointsThisWeekWaiting,
  oneDailyQuizHistoryAction,
  setActivityAction,
  setBadgesAction,
  setDailyQuizHistoryAction,
  setDashboardHeaderInfo,
  setDashboardHeaderInfoWaiting,
  setEveryoneLeaderboardAction,
  setFeaturedBlogAction,
  setFeaturedForumAction,
  setFeaturedPodcastAction,
  setFriendLeaderboardAction,
  setInviteAFRiendAction,
  setIsLoadingDailyQuizHistoryAction,
  setIsLoadingFeaturedBlogAction,
  setIsQualDailyQuizHistoryLoading,
  setLoadingReviewDailyQuiz,
  setLoadingReviewQualDailyQuiz,
  setLoadingScoringHistory,
  setOneQualDailyQuizHistoryAction,
  setPointsThisWeek,
  setQualDailyQuizHistoryAction,
  setRecomendedTopicsAction,
  setScoringHistoryAction,
  setStatsAction,
  setUpdateCycleMessage,
} from '../actions/dashboardActions';
import Services from '../services';

// for myStats component
export function* getStats(action) {
  try {
    yield put(setStatsAction({}));
    const response = yield call(Services.DashboardService.getStats);
    yield put(setStatsAction(response));
  } catch (exception) {}
}

export function* loadPointsThisWeekSaga(action) {
  try {
    yield put(loadPointsThisWeekWaiting(true));

    const response = yield call(Services.DashboardService.getPointsThisWeek);

    yield put(setPointsThisWeek(response));
    yield put(loadPointsThisWeekWaiting(false));
  } catch (exception) {
    yield put(loadPointsThisWeekWaiting(false));
  }
}

// for activity Component
export function* getActivity(action) {
  try {
    yield put(setActivityAction(null));
    const response = yield call(
      Services.DashboardService.getActivity,
      action.timePeriod,
    );
    yield put(setActivityAction(response));
  } catch (exception) {}
}

// for leaderboard component

export function* getFriendLeaderboard(action) {
  try {
    yield put(loadFriendLeaderboardWaiting(true));
    yield put(setFriendLeaderboardAction([]));

    const response = yield call(
      Services.DashboardService.getFriendLeaderboard,
      action.timePeriod,
      // action.friendLeaderboard //this response must be an array
    );

    yield put(setFriendLeaderboardAction(response));
    yield put(loadFriendLeaderboardWaiting(false));
  } catch (exception) {
    yield put(loadFriendLeaderboardWaiting(false));
  }
}

export function* getEveryoneLeaderboard(action) {
  try {
    yield put(loadEveryoneLeaderboardWaiting(true));
    yield put(setEveryoneLeaderboardAction([]));

    const response = yield call(
      Services.DashboardService.getEveryoneLeaderboard,
      action.timePeriod,
    );

    yield put(setEveryoneLeaderboardAction(response));
    yield put(loadEveryoneLeaderboardWaiting(false));
  } catch (exception) {
    yield put(loadEveryoneLeaderboardWaiting(false));
  }
}

export function* getScoringHistorySagas(action) {
  try {
    yield put(setLoadingScoringHistory(true));
    const response = yield call(
      Services.DashboardService.getScoringHistoryService,
      action.timePeriod,
    );
    yield put(setScoringHistoryAction(response));
    yield put(setLoadingScoringHistory(false));
  } catch (exception) {
    yield put(setLoadingScoringHistory(false));
  }
}
// for Badges component

export function* getBadgesSagas(action) {
  try {
    const response = yield call(
      Services.DashboardService.getBadgesService,
      action.skip,
      action.limit,
    );
    yield put(setBadgesAction(response));
  } catch (exception) {}
}

export function* getDailyQuizHistorySagas(action) {
  try {
    yield put(setIsLoadingDailyQuizHistoryAction(true));
    const response = yield call(
      Services.DashboardService.getDailyQuizHistoryService,
      action.skip,
      action.limit,
    );

    yield put(setDailyQuizHistoryAction(response, action.reset));
  } catch (exception) {
    yield put(setIsLoadingDailyQuizHistoryAction(false));
  } finally {
    yield put(setIsLoadingDailyQuizHistoryAction(false));
  }
}

export function* getQualDailyQuizHistorySagas(action) {
  try {
    yield put(setIsQualDailyQuizHistoryLoading(true));

    const response = yield call(
      Services.DashboardService.getQualDailyQuizHistoryService,
      action.skip,
      action.limit,
    );

    yield put(setQualDailyQuizHistoryAction(response, action.reset));
  } catch (error) {
  } finally {
    yield put(setIsQualDailyQuizHistoryLoading(false));
  }
}

export function* getOneDailyQuizHistorySagas(action) {
  try {
    yield put(setLoadingReviewDailyQuiz(true));
    const response = yield call(
      Services.DashboardService.getOneDailyQuizHistoryService,
      action.id,
      action.isLastQuiz,
    );
    yield put(oneDailyQuizHistoryAction(response));
  } catch (exception) {
  } finally {
    yield put(setLoadingReviewDailyQuiz(false));
  }
}

export function* getOneQualDailyQuizHistorySagas(action) {
  try {
    yield put(setLoadingReviewQualDailyQuiz(true));
    const response = yield call(
      Services.DashboardService.getOneQualDailyQuizHistoryService,
      action.id,
      action.isLastQuiz,
    );

    yield put(setOneQualDailyQuizHistoryAction(response));
  } catch (error) {
  } finally {
    yield put(setLoadingReviewQualDailyQuiz(false));
  }
}

export function* getRecomendedTopicsSagas() {
  try {
    const response = yield call(
      Services.DashboardService.getRecomendedTopicsService,
    );
    yield put(setRecomendedTopicsAction(response));
  } catch (exception) {}
}

export function* getFeaturedBlogSagas() {
  try {
    yield put(setIsLoadingFeaturedBlogAction(true));
    const response = yield call(
      Services.DashboardService.getFeaturedBlogService,
    );
    yield put(setFeaturedBlogAction(response[0]));
    yield put(setIsLoadingFeaturedBlogAction(false));
  } catch (exception) {
    yield put(setIsLoadingFeaturedBlogAction(false));
  }
}

export function* getFeaturedPodcastSagas() {
  try {
    const response = yield call(
      Services.DashboardService.getFeaturedPodcastService,
    );
    yield put(setFeaturedPodcastAction(response));
  } catch (exception) {}
}

export function* getFeaturedForumSagas() {
  try {
    const response = yield call(
      Services.DashboardService.getFeaturedForumService,
    );
    yield put(setFeaturedForumAction(response));
  } catch (exception) {}
}

export function* getInviteAFriendSagas() {
  try {
    const response = yield call(
      Services.DashboardService.getInviteAFriendService,
    );
    yield put(setInviteAFRiendAction(response));
  } catch (exception) {}
}

export function* loadDashboardHeaderInfoSaga() {
  try {
    yield put(setDashboardHeaderInfoWaiting(true));

    const response = yield call(
      Services.DashboardService.getDashboardHeaderInfo,
    );

    yield put(setDashboardHeaderInfo(response));

    yield put(setDashboardHeaderInfoWaiting(false));
  } catch (err) {
    yield put(setDashboardHeaderInfoWaiting(false));
  }
}

export function* setUserCycleSaga(action) {
  try {
    yield put(setDashboardHeaderInfoWaiting(true));
    const response = yield call(
      Services.DashboardService.setUserCycle,
      action.cycleId,
    );
    yield put(setDashboardHeaderInfoWaiting(false));
    yield call(Services.UserService.getLoggedStudent);
    yield put(
      setUpdateCycleMessage({
        type: 'success',
        text: 'Cycle updated successfully!',
      }),
    );
  } catch (err) {
    yield put(setDashboardHeaderInfoWaiting(false));
    yield put(
      setUpdateCycleMessage({ type: 'error', text: err.response.data }),
    );
  }
}

export default function* sagas() {
  yield [
    getStats(),
    getActivity(),
    getFriendLeaderboard(),
    getEveryoneLeaderboard(),
    getFeaturedBlogSagas(),
    getFeaturedPodcastSagas(),
    getFeaturedForumSagas(),
    getRecomendedTopicsSagas(),
    getBadgesSagas(),
    getDailyQuizHistorySagas(),
    getOneDailyQuizHistorySagas(),
    getInviteAFriendSagas(),
  ];
}
